import MsgList from '../views/msg/MsgList'
import WebsiteMsg from '../views/msg/WebsiteMsg'

const msgs = [
  {
    path: '/MsgList',
    name: 'MsgList',
    component: MsgList,
  },
  {
    path: '/WebsiteMsg',
    name: 'WebsiteMsg',
    component: WebsiteMsg,
  },
]


export default msgs